import { render } from "./Imunisasi.vue?vue&type=template&id=473e3f89"
import script from "./Imunisasi.vue?vue&type=script&lang=js"
export * from "./Imunisasi.vue?vue&type=script&lang=js"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__